import { createSlice } from '@reduxjs/toolkit';

const leadSlice = createSlice({
  name: 'leadSlice',
  initialState: {
    leads: [],
    totalRowCount: 0,
    isLoading: false,
  },
  reducers: {
    setLeads: (state, action) => {
      state.leads = action.payload.data.lead;
      state.totalRowCount = action.payload.data.totalRowCount;
    },
    setLoading: (state, action) => {
      state.isLoading = action.payload;
    },
  },
});

export const { setLeads, setLoading } = leadSlice.actions;
export default leadSlice.reducer;
